import { ApiEnum } from "../../constants/ApiEnum";
import axios, { AxiosResponse } from "axios";
import { disableApiError } from "../../../app/rootReducer";
import { Dispatch } from "redux";

interface ApiDossierDeleteData {
    data: {
        status: {
            message: object;
        };
    };
}

export const ApiDossierDelete = async (
    dossierUuid: string,
    fundingType: string,
    dispatch: Dispatch,
): Promise<AxiosResponse<ApiDossierDeleteData>> => {
    return await axios
        .delete(ApiEnum.DOSSIER + "/delete", {
            data: {
                uuid: dossierUuid,
                funding_type: fundingType,
            },
        })
        .then(function (response) {
            dispatch(disableApiError());
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
};
